/**
 * Hierarchy Service
 * Handles hierarchy configuration API calls
 */

import { api } from '../lib/axios';

export interface HierarchyLevel {
  id?: string;
  levelNumber: number;
  roleName: string;
}

export interface HierarchyConfig {
  manufacturerId: string;
  levels: HierarchyLevel[];
  hasConfig: boolean;
}

class HierarchyService {
  /**
   * Get hierarchy configuration
   */
  async getConfig(): Promise<HierarchyConfig> {
    const response = await api.get('/hierarchy/config');
    return response.data.data;
  }

  /**
   * Save hierarchy configuration
   */
  async saveConfig(levels: HierarchyLevel[]): Promise<HierarchyConfig> {
    const response = await api.post('/hierarchy/config', { levels });
    return response.data.data;
  }

  /**
   * Get role name for a specific level
   */
  async getRoleName(levelNumber: number): Promise<string> {
    const response = await api.get(`/api/hierarchy/role/${levelNumber}`);
    return response.data.data.roleName;
  }
}

export const hierarchyService = new HierarchyService();
